import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-2 inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-800"
}
const _hoisted_2 = { key: 0 }

import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CnameChainBadge',
  props: {
  chain: {
    type: Array as () => Array<string>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.chain.length > 0)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createTextVNode(" For CNAME  "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.chain, (cname, index) => {
          return (_openBlock(), _createElementBlock("span", { key: index }, [
            (index !== 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " ← "))
              : _createCommentVNode("", true),
            _createVNode(DnsRecordsLink, {
              domain: cname,
              class: "text-blue-600 hover:text-blue-800 hover:underline"
            }, null, 8, ["domain"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})